<template>
  <v-container grid-list-md px-1 pb-0>
    <v-layout wrap>
      <v-flex xs12>
        <h2>Gekoppelde klant</h2>
        <v-checkbox v-if="optional" v-model="useTempCustomer" label="Gebruiken"></v-checkbox>
      </v-flex>
      <template v-if="showForm || !optional">
        <v-flex xs6 sm6 md6>
          <v-text-field label="Naam" :required="editable" v-model="user.t_name" :rules="basicRules"></v-text-field>
        </v-flex>
        <v-flex xs6 sm6 md6>
          <v-text-field
            label="Geboortedatum"
            :required="editable"
            v-model="user.t_birthDate"
            autocomplete="false"
            :rules="basicRules"
          ></v-text-field>
        </v-flex>
        <v-flex xs6 sm6 md6>
          <v-text-field
            label="Rijbewijsnummer"
            :required="editable"
            v-model="user.t_licenseId"
            autocomplete="false"
            :rules="basicRules"
          ></v-text-field>
        </v-flex>
        <v-flex xs6 sm6 md6>
          <v-text-field
            label="Telefoonnummer"
            :required="editable"
            v-model="user.t_phoneno"
            autocomplete="false"
            :rules="basicRules"
          ></v-text-field>
        </v-flex>
        <v-flex xs6 sm6 md6>
          <v-text-field
            label="E-mailadres"
            :required="editable"
            v-model="user.t_emailAddress"
            autocomplete="false"
            :rules="basicRules"
          ></v-text-field>
        </v-flex>
        <v-flex xs6 sm6 md6 v-model="useForInvoice" v-if="showInvoiceOption">
          <v-checkbox label="Toon op factuur" v-model="useForInvoice"></v-checkbox>
        </v-flex>
      </template>
    </v-layout>
  </v-container>
</template>
    
<script>
import * as utils from '@/utils/utils';
import moment from 'moment';
import { _ } from 'vue-underscore';
export default {
	name: 'TempCustomer',
	components: {},
	mounted: function() {
		this.useTempCustomer = this.user && this.user.t_name;
	},
	updated: function() {
		this.user.useTempCustomer = this.useTempCustomer;
	},
	data() {
		return {
			basicRules: [v => !!v || 'Verplicht veld'],
			useTempCustomer: false
		};
	},
	props: [
		'user',
		'editable',
		'optional',
		'showInvoiceOption',
		'useTempForInvoice'
	],
	computed: {
		useForInvoice: {
			get() {
				return this.useTempForInvoice === '1';
			},
			set(value) {
				this.$emit('setUseTempForInvoice', value);
			}
		},
		showForm: {
			get() {
				return this.user.t_name || this.useTempCustomer ? true : false;
			},
			set(value) {
				this.showForm = value;
			}
		}
	},
	watch: {
		user(value) {
			this.useTempCustomer = value && value.t_name ? true : false;
		},
		useTempCustomer(value) {
			this.user.useTempCustomer = value;
		}
	}
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/subcomponents/TempCustomer.vue